module.exports = __webpack_public_path__ + "static/img/business01.2e74e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/business01.png
// module id = ew+j
// module chunks = 1